import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=0cb4e52a&"
import script from "./TagList.vue?vue&type=script&lang=ts&"
export * from "./TagList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports